module.exports = __webpack_public_path__ + "media/images/icon-activity-6867b9ff.svg";